/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseListProduct } from '../../models/api-response-list-product';
import { Product } from '../../models/product';

export interface SyncProductsFromWordpress$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
      body: Array<Product>
}

export function syncProductsFromWordpress(http: HttpClient, rootUrl: string, params: SyncProductsFromWordpress$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseListProduct>> {
  const rb = new RequestBuilder(rootUrl, syncProductsFromWordpress.PATH, 'post');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseListProduct>;
    })
  );
}

syncProductsFromWordpress.PATH = '/v1/api/products/external-sync/products';
